import api from "@/Library/api.js";
import method from "@/Library/method.js";
let apiresult;
let controller;
let action;
let url;

export default {

    
    /** 获取分类数据统计 **/
    GET_OPERATE_DATE(data) {
        controller='EsStat';
        action='GetOperateData';
        url='/'+controller+'/'+action;
        return api({ url: url, method: "post", data: data }); 
    },

    /** 获取总趋势图、分布图数据 **/
    GET_OPERATE_PIE(data) {
        controller='EsStat';
        action='GetOperatePieData';
        url='/'+controller+'/'+action;
        return api({ url: url, method: "post", data: data }); 
    },

    /** 查看分类数据统计 **/
    GET_CATE_STAT_DATE(data) {
        controller='EsStat';
        action='GetGetCateStatDate';
        url='/'+controller+'/'+action;
        return api({ url: url, method: "post", data: data }); 
    },

    /** 查看分类数据统计趋势图 **/
    GET_CATE_STAT_DATE_PIE(data) {
        controller='EsStat';
        action='GetGetCateStatPieDate';
        url='/'+controller+'/'+action;
        return api({ url: url, method: "post", data: data }); 
    },

    /** 获取今日统计信息 **/
    GET_STAT_INFO(data) {
        controller='EsStat';
        action='GetStatInfo';
        url='/'+controller+'/'+action;
        return api({ url: url, method: "post", data: data }); 
    },

    /** 获取今日分类点击率信息 **/
    GET_STAT_CATE_HITS_INFO(data) {
        controller='EsStat';
        action='GetCateHitsDate';
        url='/'+controller+'/'+action;
        return api({ url: url, method: "post", data: data }); 
    },

    /** 获取今日商品点击率信息 **/
    GET_STAT_GOODS_HITS_INFO(data) {
        controller='EsStat';
        action='GetGoodsHitsDate';
        url='/'+controller+'/'+action;
        return api({ url: url, method: "post", data: data }); 
    },

    /** 获取今日时间段流量信息 **/
    GET_STAT_FLOW_HOURS_INFO(data) {
        controller='EsStat';
        action='GetFlowFromHours';
        url='/'+controller+'/'+action;
        return api({ url: url, method: "post", data: data }); 
    },

    /** 获取今日页面访问次数统计 **/
    GET_STAT_PAGE_VIEW_INFO(data) {
        controller='EsStat';
        action='GetFlowFromPage';
        url='/'+controller+'/'+action;
        return api({ url: url, method: "post", data: data });
    },

   
}